import { render, staticRenderFns } from "./channel-item.vue?vue&type=template&id=57ed0eaa&scoped=true&"
import script from "./channel-item.vue?vue&type=script&lang=js&"
export * from "./channel-item.vue?vue&type=script&lang=js&"
import style0 from "./channel-item.vue?vue&type=style&index=0&id=57ed0eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ed0eaa",
  null
  
)

/* custom blocks */
import block0 from "../locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fmessage-channels%2Fcomponents%2Fchannel-item.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports